module.exports = __webpack_public_path__ + "img/barcode.2058e53d.jpg";